// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"styles_textBlock__EMWWu","fullColumn":"styles_fullColumn__UN48P"};